export class ProductField {
  constructor(
    name?: string,
    type?: string,
    sortId?: number,
    printTitle?: boolean,
    status?: string
  ) {
    this.name = name;
    this.type = type;
    this.sortId = sortId;
    this.printTitle = printTitle;
    this.status = status;
  }
  name: string;
  type: string;
  sortId: number;
  printTitle: boolean;
  status: string;
}
